var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityPowerSupply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -901.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Power-supply",
    transform: "translate(2734.000000, 901.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8683903,9.25046866 C26.1284447,4.43056796 22.1187399,0.610646654 17.2690969,0.0706577779 C10.6195863,-0.669326978 5,4.50056652 5,11.0004326 C5,14.1903669 6.34990063,17.050308 8.50974165,19.0602666 C10.0896254,20.5202365 10.9995584,22.5501947 10.9995584,24.7001504 L10.9995584,25.0001442 L14.999264,25.0001442 L14.999264,17.3203024 C13.8293501,16.9203107 12.9994112,15.8103335 12.9994112,14.5003605 C12.9994112,12.8403947 14.3393125,11.5004223 15.9991903,11.5004223 C17.6590682,11.5004223 18.9989695,12.8403947 18.9989695,14.5003605 C18.9989695,15.8103335 18.1690306,16.9203107 16.9991167,17.3203024 L16.9991167,25.0001442 L20.9988223,25.0001442 L20.9988223,24.7101502 C20.9988223,22.5101955 21.9887495,20.4802373 23.5786324,18.9702684 C26.0684491,16.6003172 27.4483476,13.0803898 26.8683903,9.25046866 L26.8683903,9.25046866 Z M20.9988223,29.0000618 C20.9988223,30.6460279 19.644922,32 17.9990431,32 L13.9993376,32 C12.3534587,32 10.9995584,30.6460279 10.9995584,29.0000618 L10.9995584,27.000103 L20.9988223,27.000103 L20.9988223,29.0000618 Z",
    id: 72
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityPowerSupply);
export default __webpack_public_path__ + "static/media/transport-and-utility-power-supply.0865f1d9.svg";
export { ForwardRef as ReactComponent };